import { createAction, Dispatch } from '@reduxjs/toolkit';
import DeploymentApi from '../../api/deploymentApi';
import { DeploymentModel } from '../../models/deploymentModel';
import { AppError } from '../../types/appError';

export const deploymentFetchAllRequestAction = createAction<void>('deployment/fetchAllRequest');
export const deploymentFetchAllSuccessAction = createAction<DeploymentModel[]>('deployment/fetchAllSuccess');
export const deploymentFetchAllFailureAction = createAction<AppError>('deployment/fetchAllFailure');

export const fetchAllDeployments = () => async (dispatch: Dispatch) => {
  dispatch(deploymentFetchAllRequestAction());
  try {
    const allDeployments = await DeploymentApi.fetchAll();
    dispatch(deploymentFetchAllSuccessAction(allDeployments));
  } catch (error) {
    dispatch(deploymentFetchAllFailureAction(error as AppError));
  }
}

export const fetchDeploymentRequestAction = createAction<void>('deployment/fetchDeploymentRequest');
export const fetchDeploymentSuccessAction = createAction<DeploymentModel>('deployment/fetchDeploymentSuccess');
export const fetchDeploymentFailureAction = createAction<AppError>('deployment/fetchDeploymentFailure');

export const fetchDeployment = (deploymentId: string) => async (dispatch: Dispatch) => {
  dispatch(fetchDeploymentRequestAction());
  try {
    const oneDeployment = await DeploymentApi.fetchDeployment(deploymentId);
    dispatch(fetchDeploymentSuccessAction(oneDeployment));
  } catch (error) {
    dispatch(fetchDeploymentFailureAction(error as AppError));
  }
}
